module.exports = __webpack_public_path__ + "static/img/rank_231.106c349.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_231.png
// module id = 6FMF
// module chunks = 0